import axios from "axios";
import router from "@/router";
import quote from "./modules/quote";
import accessorials from "./modules/accessorials";
import commodity from "./modules/commodity";
import haul from "./modules/haul";
import xenon from "./modules/xenon";
import reportSlack from "./modules/reportSlack";
import { errorMessage, tokenExpired, errorAlert } from "@/api/errorMessages";
import * as api from "@/api/oauth";

export default {
  namespaced: true,
  state: {
    trips: null,
    hauls: [],
    quoteByIdAux: null,
    totalQuotes: null,
    items: null,
    quoteById: null,
    deleteQuote: 0,
    quoteSended: null,
    message: 0,
    body: {
      charlie_status: null,
      is_read: true,
      is_deleted: false,
      is_quote: true
    },
    keyComponent: 0,
    actualQueue: null,
    totalQuotesAssigned: null,
    totalQuotesFailed: null
  },
  getters: {
    showTotalQuotes(state) {
      return state.totalQuotes;
    },
    showItems(state) {
      return state.items;
    },
    showQuoteById(state) {
      return state.quoteById;
    },
    showQuoteByIdAux(state) {
      return state.quoteByIdAux;
    },
    showhauls(state) {
      return state.hauls;
    },
    showTrips(state) {
      return state.trips;
    },
    showBody(state) {
      return state.body;
    },
    showKeyComponent(state) {
      return state.keyComponent;
    },
    showActualQueue(state) {
      return state.actualQueue;
    },
    showTotalQuotesAssigned(state) {
      return state.totalQuotesAssigned;
    },
    showTotalQuotesFailed(state) {
      return state.totalQuotesFailed;
    }
  },
  mutations: {
    setTotalQuotes(state, newTotalQuotes) {
      state.totalQuotes = newTotalQuotes;
    },
    setItems(state, newItems) {
      state.items = newItems;
    },
    setQuoteById(state, newQuoteById) {
      state.quoteById = newQuoteById;
    },
    setQuoteByIdAux(state, newQuoteById) {
      state.quoteByIdAux = newQuoteById;
    },
    deleteQuote(state) {
      state.deleteQuote += 1;
    },
    setHauls(state, newHauls) {
      state.hauls = newHauls;
    },
    addHaul(state, newHaul) {
      state.hauls.push(newHaul);
    },
    setTrips(state, newTrips) {
      state.trips = newTrips;
    },
    updateMessage(state) {
      state.message += 1;
    },
    setKeyComponent(state) {
      state.keyComponent += 1;
    },
    setActualQueue(state, newActualQueue) {
      state.actualQueue = newActualQueue;
    },
    setTotalQuotesAssigned(state, newTotalQuotesAssigned) {
      state.totalQuotesAssigned = newTotalQuotesAssigned;
    },
    setTotalQuotesFailed(state, newTotalQuotesFailed) {
      state.totalQuotesFailed = newTotalQuotesFailed;
    }
  },
  actions: {
    async getTotalQuotes({ commit, getters, rootGetters }, info) {
      let userAux = rootGetters["login/showUserLoggedIn"][0];
      let body = getters.showBody;
      body.entry_type = info.entry_type;
      if (
        userAux.rol.name != "superuser" &&
        router.currentRoute.params.pathName != "queue" &&
        router.currentRoute.params.pathName != "sent" &&
        router.currentRoute.params.pathName != "spanish-queue"
      ) {
        body.user_id = userAux.user.id;
      } else if (userAux.rol.name == "superuser") {
        delete body.user_id;
        if (router.currentRoute.params.pathName == "alerts") {
          if (info.validation_alert == false) {
            body = {
              entry_type: info.entry_type,
              charlie_status: info.status,
              is_deleted: false,
              is_quote: true,
              is_read: true
            };
          } else {
            body = {
              entry_type: info.entry_type,
              charlie_status: info.status,
              is_deleted: false,
              is_quote: true,
              is_read: true,
              validation_alert: info.validation_alert
            };
          }
        }
      } else if (
        router.currentRoute.params.pathName == "sent" ||
        router.currentRoute.params.pathName == "queue"
      ) {
        if (info.department === "2") {
          body.user_id = userAux.user.id;
        } else if (info.department === "1") {
          body.entry_type = [
            "GRAPH",
            "Manual",
            "GRAPH-KNSUPPORT",
            "GRAPH-LATINPRO"
          ];
        }
        delete body.user_id;
      }
      if (router.currentRoute.params.pathName == "spanish-queue") {
        body.language_classification = info.language_classification;
      } else {
        delete body.language_classification;
      }
      body.charlie_status = info.status;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/count/${info.department}/`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setTotalQuotes", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getTotalQuotesAssigned({ commit }, info) {
      let body = {};
      body.entry_type = info.entry_type;
      body.is_deleted = router.currentRoute.params.pathName === "deleted";
      if (router.currentRoute.params.pathName !== "deleted") {
        body.is_quote = router.currentRoute.params.pathName !== "unknown";
        body.charlie_status = info.status;
        body.is_read = true;
      }
      if (router.currentRoute.params.pathName == "myQueue") {
        body.user_id = JSON.parse(
          localStorage.getItem("charlie-username-otr")
        )[0].user.id;
      } else {
        if (info.department === "1") {
          body.entry_type = [
            "GRAPH",
            "Manual",
            "GRAPH-KNSUPPORT",
            "GRAPH-LATINPRO"
          ];
        }
        if (
          router.currentRoute.params.pathName !== "deleted" &&
          router.currentRoute.params.pathName !== "unknown"
        ) {
          body.user_id = JSON.parse(
            localStorage.getItem("charlie-username-otr")
          )[0].user.id;
        }
      }
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/count/${info.department}/`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setTotalQuotes", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getTotalUnassigned({ commit }, info) {
      let entryType;
      let entryTypeArray = [];
      let params = {};
      if (router.currentRoute.params.pathName == "spanish-queue") {
        params.language_classification = info.language_classification;
      } else {
        delete params.language_classification;
      }
      for (let i in info.entry_type) {
        entryType = "entry_type=" + info.entry_type[i] + "&";
        entryTypeArray.push(entryType);
      }
      entryType = entryTypeArray.join("");
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/unassigned/${info.department}/count?${entryType}`,
          {
            params: params,
            ...api.getToken()
          }
        );
        if (response.status == 200) {
          commit("setTotalQuotes", response.data);
        }
        return response.data;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getMainQueue({ commit }, info) {
      let entryType;
      let entryTypeArray = [];
      let params = {};
      for (let i in info.entry_type) {
        entryType = "entry_type=" + info.entry_type[i] + "&";
        entryTypeArray.push(entryType);
      }
      entryType = entryTypeArray.join("");
      if (router.currentRoute.params.pathName == "spanish-queue") {
        params.language_classification = info.language_classification;
      } else {
        delete params.language_classification;
      }
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/unassigned/${info.department}/?${entryType}limit=20&skip=${info.page}`,
          {
            params: params,
            ...api.getToken()
          }
        );
        if (response.status == 200) {
          commit("setItems", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async getQuotesNonDeletedMyQueue(
      { commit, getters, rootGetters, dispatch },
      info
    ) {
      let userAux = rootGetters["login/showUserLoggedIn"][0];
      let body = getters.showBody;
      if (info.rol_name !== "superuser") {
        body.entry_type = info.entry_type;
        body.user_id = userAux.user.id;
      }
      if (info.rol_name == "superuser") {
        delete body.user_id;
      }
      body.entry_type = info.entry_type;
      body.charlie_status = info.status;
      if (router.currentRoute.params.pathName == "deleted") {
        body = {
          entry_type: info.entry_type,
          is_deleted: true
        };
      } else if (router.currentRoute.params.pathName == "unknown") {
        body = {
          entry_type: info.entry_type,
          is_quote: false,
          is_deleted: false,
          is_read: true,
          charlie_status: info.status
        };
      } else if (
        router.currentRoute.params.pathName === "sent" ||
        router.currentRoute.params.pathName === "queue" ||
        router.currentRoute.params.pathName === "spanish-queue"
      ) {
        body = {
          entry_type: info.entry_type,
          charlie_status: info.status,
          is_quote: true,
          is_deleted: false,
          is_read: true
        };
        if (router.currentRoute.params.pathName === "spanish-queue") {
          body.language_classification = info.language_classification;
        } else {
          delete body.language_classification;
        }
      } else if (router.currentRoute.params.pathName == "alerts") {
        if (info.validation_alert == false) {
          body = {
            entry_type: info.entry_type,
            charlie_status: info.status,
            is_deleted: false,
            is_quote: true,
            is_read: true
          };
        } else {
          body = {
            entry_type: info.entry_type,
            charlie_status: info.status,
            is_deleted: false,
            is_quote: true,
            is_read: true,
            validation_alert: info.validation_alert
          };
        }
      }
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/get-all/basic/${info.department}/?skip=${info.page}&limit=20&is_superuser=${info.is_superuser}`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setItems", response.data);
        }
        return response;
      } catch (err) {
        if (!err.response) {
          errorMessage();
          return;
        }
        if (err.response.status == 403) {
          if (info.is_superuser) {
            let route = "quotes/getQuotesNonDeletedMyQueue";
            let response = await dispatch("login/refreshToken", route, {
              root: true
            });
            if (response.status == 401) {
              tokenExpired();
            }
          } else {
            tokenExpired();
          }
        } else if (err.response.status == 401) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async changeStatus({ commit, rootGetters }, info) {
      let body = {
        message_id: info.quotes
      };
      if (info.assignButton === "assign") {
        body.user_id = rootGetters["login/showUserLoggedIn"][0].user.id;
      }
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/send-queue/`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("setQuoteById", response.data);
        }
        if (response.detail == 400) {
          commit("setQuoteById", response.data);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status == 400) {
          const detail = err.response.data?.detail;
          detail ? errorAlert("Error", detail) : errorMessage();
        }
        return err.response;
      }
    },

    async deleteQuotes({ commit }, quotes) {
      let body = {
        message_id: quotes
      };
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("deleteQuote");
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async searchQuote({ commit }, info) {
      let entryType;
      let entryTypeArray = [];
      for (let i in info.entry_type) {
        entryType = "&entry_type=" + info.entry_type[i];
        entryTypeArray.push(entryType);
      }
      entryType = entryTypeArray.join("");
      let params = {};
      params.subject = info.subject;
      params.is_quote = info.isQuote;
      params.charlie_status = info.charlieStatus;
      params.is_read = info.isRead;
      params.is_deleted = info.isDeleted;
      params.limit = info.limit;
      params.is_superuser = info.is_superuser;
      if (info.userId) {
        params.user_id = info.userId;
      }
      try {
        let response = await axios.get(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/message/search/?department=${info.departmentId}${entryType}`,
          {
            params,
            ...api.getToken()
          }
        );
        if (response.status == 200) {
          commit("setItems", response.data);
          commit("setTotalQuotes", response.data.length);
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async updateMessage({ commit }, info) {
      try {
        let response = await axios.put(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/${info.messageId}/`,
          info.body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("updateMessage");
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async sendQuote({ commit }, info) {
      let body = {
        id: info.id,
        html: info.html,
        language: info.language
      };
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE +
            `/api/quote/quotation/?is_superuser=${info.is_superuser}`,
          body,
          api.getToken()
        );
        if (response.status == 200) {
          commit("updateMessage");
        }
        return response;
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },

    async sendHyperCubes(__, info) {
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/hypercubes/quotation/`,
          info,
          api.getToken()
        );
        if (response.status == 200) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    },
    async createQuote(__, info) {
      let body = {};
      body.department_ = info.department;
      body.subject = info.subject;
      body.entry_type = info.entry_type;
      try {
        let response = await axios.post(
          process.env.VUE_APP_BACK_ROUTE + `/api/message/create-manual`,
          body,
          api.getToken()
        );
        if (response.status == 201) {
          return response;
        }
      } catch (err) {
        if (err.response.status == 403) {
          tokenExpired();
        } else if (err.response.status == 422) {
          errorAlert("Error", "There is something wrong");
        } else if (err.response.status != 200) {
          errorMessage();
        }
        return err.response;
      }
    }
  },
  modules: {
    quote,
    accessorials,
    commodity,
    haul,
    xenon,
    reportSlack
  }
};
